import { retryPlaidSync } from '@/actions/plaid/authActions'
import { setPlaidTarget } from '@/reducers/finances/plaidLauncherReducer'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useSyncStatusContext } from './SyncStatusContext'

/**
 * Shared Plaid sync-recovery actions for the self-serve bank surfaces (the page-level
 * error banner and the per-account error indicators). `reconnect` hands off to the
 * page-level `PlaidLauncher` via `setPlaidTarget`; `retry` re-runs the sync and restarts
 * polling (`refetch`) so the UI reflects the new sync state.
 */
export const usePlaidRecovery = () => {
  const dispatch = useAppDispatch()
  const { refetch } = useSyncStatusContext()

  const reconnect = (accountId: number) =>
    dispatch(setPlaidTarget({ mode: 'reconnect', accountId }))

  const retry = async (plaidItemId: number) => {
    await dispatch(retryPlaidSync(plaidItemId))
    refetch()
  }

  return { reconnect, retry }
}
